var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.selectedRisk === _vm.RISK.RR)?_c('rain-radar-layer'):(_vm.selectedRisk === _vm.RISK.RT)?_c('rain-total-layer'):(_vm.selectedRisk === _vm.RISK.FL)?_c('flood-layer'):(_vm.selectedRisk === _vm.RISK.VWS)?_c('virtual-water-surface-layers'):(_vm.selectedRisk === _vm.RISK.GR)?_c('guerrilla-rain-layer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }